import React, { ReactNode } from 'react';
import {
  ExperiencePerformanceTypes,
  ExperienceSuccess,
  ExperienceTypes,
  UFOExperience,
  useUFOComponentExperience,
} from '@atlassian/ufo';

export interface UFOPageProps {
  pageId: string;
  children: ReactNode;
}

export const UFOPage = ({ pageId, children }: UFOPageProps) => {
  const experience = pageLoadExperience(pageId);
  useUFOComponentExperience(experience);

  return (
    <>
      {children}
      <ExperienceSuccess experience={experience}></ExperienceSuccess>
    </>
  );
};

// eslint-disable-next-line
export function withUFOWrapper<T extends {}>(WrappedComponent: React.FC<T>, componentName: string) {
  const ComponentWrapper = (props: T) => {
    return (
      <UFOPage pageId={componentName}>
        <WrappedComponent {...props}></WrappedComponent>
      </UFOPage>
    );
  };
  ComponentWrapper.displayName = `WithUFOWrapper(${componentName})`;
  return ComponentWrapper;
}

const pageLoadExperience = (pageId: string) => {
  return new UFOExperience(pageId, {
    category: 'PRODUCT',
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
  });
};
